/* ──────────────────────────────────────────────────────────────
   custom-option-price.js.liquid
   • Watches every radio that has a data‑variant‑id attribute
   • When changed, it reads the matching variant in
     window.PROSPEC_VARIANTS and rewrites the price text
   • Works with any theme currency, handles compare‑at price
   • Requires window.PROSPEC_VARIANTS = null
     to be output BEFORE this script tag (see product‑info.liquid)
   ──────────────────────────────────────────────────────────── */
(function () {
  /* Helpers */
  function formatMoney(cents) {
    const money = (cents / 100);
    return money.toLocaleString(window.Shopify?.locale || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  
  const variantRadios = document.querySelectorAll('input[type="radio"][data-variant-id]');
  const priceWrapper  = document.querySelector('.product-meta__price-list-container .price-list');
  
  if (!variantRadios.length || !priceWrapper || !window.PROSPEC_VARIANTS) return;
  
  /* Build a quick lookup map { id : variantObject } */
  const variantMap = {};
  window.PROSPEC_VARIANTS.forEach(v => { variantMap[v.id] = v; });
  
  /* Listener */
  variantRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      
      const v = variantMap[radio.dataset.variantId];
      if (!v) return;
      
      /* Re‑render the price HTML exactly like Focal does */
      const compareAt = v.compare_at_price || 0;
      const priceHtml = compareAt > v.price
        ? `<span class="price price--highlight price--large">
             <span class="visually-hidden">Sale price</span>${ formatMoney(v.price) }
           </span>
           <span class="price price--compare">
             <span class="visually-hidden">Regular price</span>${ formatMoney(compareAt) }
           </span>`
        : `<span class="price price--large">
             <span class="visually-hidden">Price</span>${ formatMoney(v.price) }
           </span>`;
      
      priceWrapper.innerHTML = priceHtml;
      
      /* Update ALL hidden variant inputs in cart forms - FIXED VERSION */
      const hiddenInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      hiddenInputs.forEach(input => input.value = v.id);
      
      /* Also try the original selector as backup */
      const hiddenBackup = document.querySelector('input[name="id"][disabled]');
      if (hiddenBackup) hiddenBackup.value = v.id;
    });
  });
})();

